import { i18n } from '@lingui/core';
import React from 'react';
import { useSearchData } from '../../data/SearchData';

type CounterProps = {
    className?: string;
};

export function Counter(props: CounterProps) {
    const { className = '' } = props;

    const { matchCount } = useSearchData();

    return (
        <span className={className}>
            <span className="font-bold">{matchCount}</span>
            {` ${i18n.t({
                id: 'results.count',
                message: 'results',
            })}`}
        </span>
    );
}
